import React from 'react'
import useApp from "../../store/app/appContext";
import NotificationCard from '../../components/Cards/NotificationCard';

function MyNotifications() {
  
  const {
    appState: { userNotifications },
  } = useApp();

  return (
    <div className='w-full h-full bg-white rounded shadow py-6 md:py-12 px-4 md:px-10'>
      <div className='flex justify-between items-center'>
        <h1 className="mb-4 text-2xl text-secondary">Notifications</h1>
      </div>
      <div className='h-96 md:h-full w-full md:overflow-scroll pr-4'>
        
        {userNotifications.length ? 
        userNotifications.map((notification, index) =><NotificationCard key={index} className={Boolean(index % 2) ? 'bg-light' : 'bg-white'} notification={notification}/>)
        :
        <span>No notifications to show</span> 
        }
      </div>
      
    </div>
  )
}

export default MyNotifications;